module.exports = __webpack_public_path__ + "static/media/22ESCWA19.344cbc8b.jpg";